import AdditionalServices from 'src/components/AdditionalServices/AdditionalServices';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, AppointmentActionCreator, SpecsActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    inquiryInvoked: state.AdditionalServices.allServices.inquiryInvoked,
    inquiryReturned: state.AdditionalServices.recallData.inquiryReturned,
    inquiryError: state.AdditionalServices.recallData.inquiryError,
    showWeOwes: state.Specs.specs?.showWeOwes,
    showOEMRecall: state.Specs.specs?.showOEMRecall,
    showPrvRecom: state.Specs.specs?.showPrvRecom,
    additionalServices: state.AdditionalServices,
    apptOps: state.Appointment.ApptOps,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    skipServicesFlag: state.Specs.specs?.skipServicesFlag,
    vehicleSpecs: state.Specs.specs,
    skipServices: !(state.Specs.specs?.skipServicesFlag ?? false) && !(state.Specs.specs?.showWrtYourOwn ? true : false) &&
        !(state.Specs.specs?.showDiagnTool ? true : false) && state.WebOps.WebOps?.length === 0 &&
        state.Menus.allMenus.menus.length === 0,
    apptDept: state.Appointment.Appointment.department,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    locale: state.Framework.locale,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    theme: state.Framework.theme,
    countryCode: state.Framework.dealerCountry,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalServices);